import { DeviceTypes } from "../../config";

import * as Base from "./base";
import * as ActuatorThreeWay from "./ActuatorThreeWay";
import * as ActuatorTwoWay from "./ActuatorTwoWay";
import * as AutoFill from "./AutoFill";
import * as Blower from "./Blower";
import * as Button from "./Button";
import * as ChemicalPump from "./ChemicalPump";
import * as Chiller from "./Chiller";
import * as ChlorineSensor from "./ChlorineSensor";
import * as Cleaner from "./Cleaner";
import * as Cover from "./Cover";
import * as DoorSensor from "./DoorSensor";
import * as DissolvedOxygenSensor from "./DissolvedOxygenSensor";
import * as FillSwitch from "./FillSwitch";
import * as Filter from "./Filter";
import * as Fire from "./Fire";
import * as FlowMeter from "./FlowMeter";
import * as FlowRelay from "./FlowRelay";
import * as FlowSwitch from "./FlowSwitch";
import * as GenericOnOff from "./GenericOnOff";
import * as Heater from "./Heater";
import * as HeatPump from "./HeatPump";
import * as Light from "./Light";
import * as LightDriver from "./LightDriver";
import * as ORPProbe from "./ORPProbe";
import * as Ozonator from "./Ozonator";
import * as PHProbe from "./PHProbe";
import * as PressureSensor from "./PressureSensor";
import * as Pump from "./Pump";
import * as Remote from "./Remote";
import * as SaltCell from "./SaltCell";
import * as SolarHeater from "./SolarHeater";
import * as T from "./T";
import * as Thermistor from "./Thermistor";
import * as UvSanitizer from "./UvSanitizer";
import * as WaterLevelSensor from "./WaterLevelSensor";

const PoolDeviceClasses = {
    [ DeviceTypes.ACTUATORTHREEWAY ]: ActuatorThreeWay,
    [ DeviceTypes.ACTUATORTWOWAY ]: ActuatorTwoWay,
    [ DeviceTypes.AUTOFILL ]: AutoFill,
    [ DeviceTypes.BLOWER ]: Blower,
    [ DeviceTypes.BUTTON ]: Button,
    [ DeviceTypes.CHEMICALPUMP ]: ChemicalPump,
    [ DeviceTypes.CHILLER ]: Chiller,
    [ DeviceTypes.CHLORINESENSOR ]: ChlorineSensor,
    [ DeviceTypes.CLEANER ]: Cleaner,
    [ DeviceTypes.COVER ]: Cover,
    [ DeviceTypes.DOORSENSOR ]: DoorSensor,
    [ DeviceTypes.DISSOLVEDOXYGENSENSOR ]: DissolvedOxygenSensor,
    [ DeviceTypes.FILLSWITCH ]: FillSwitch,
    [ DeviceTypes.FILTER ]: Filter,
    [ DeviceTypes.FIRE ]: Fire,
    [ DeviceTypes.FLOWMETER ]: FlowMeter,
    [ DeviceTypes.FLOWRELAY ]: FlowRelay,
    [ DeviceTypes.FLOWSWITCH ]: FlowSwitch,
    [ DeviceTypes.GENERICONOFF ]: GenericOnOff,
    [ DeviceTypes.HEATER ]: Heater,
    [ DeviceTypes.HEATPUMP ]: HeatPump,
    [ DeviceTypes.LIGHT ]: Light,
    [ DeviceTypes.LIGHTDRIVER ]: LightDriver,
    [ DeviceTypes.ORPPROBE ]: ORPProbe,
    [ DeviceTypes.OZONATOR ]: Ozonator,
    [ DeviceTypes.PHPROBE ]: PHProbe,
    [ DeviceTypes.PRESSURESENSOR ]: PressureSensor,
    [ DeviceTypes.PUMP ]: Pump,
    [ DeviceTypes.REMOTE ]: Remote,
    [ DeviceTypes.SALTCELL ]: SaltCell,
    [ DeviceTypes.SOLARHEATER ]: SolarHeater,
    [ DeviceTypes.T ]: T,
    [ DeviceTypes.THERMISTOR ]: Thermistor,
    [ DeviceTypes.UVSANITIZER ]: UvSanitizer,
    [ DeviceTypes.WATERLEVELSENSOR ]: WaterLevelSensor,
} as const;

export default PoolDeviceClasses;

export const PoolDeviceClassBase = Base;
